import ImageCropper from './src/main';

/* istanbul ignore next */
ImageCropper.install = function(Vue) {
  Vue.component(ImageCropper.name, ImageCropper);
};

export default ImageCropper;
